import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { SelectTime } from 'src/app/core/models/user';

export interface PeriodicElement {

  time: string;
  mon: Date;
  tue: Date;
  wed: Date;
  thu: Date;
  fri: Date;
  sat: Date;
  sun: Date;
  hours: string;
  class: string;
}
export interface SelectedTimeRange {
  dayOfWeek: string;
  start: string;
  end: string;
}

@Component({
  selector: 'app-availability-component',
  templateUrl: './availability-component.component.html',
  styleUrls: ['./availability-component.component.scss']
})
export class AvailabilityComponentComponent implements OnInit, OnChanges {
  @ViewChild('timeRangeTable', { read: ElementRef })
  timeRangeTable: ElementRef;


  @Output()
  times = new EventEmitter<any[]>();

  @Input()
  selectedTimeRange: SelectedTimeRange[] = [];


  displayedColumns: string[] = ['Time', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  timeRangeDisplayedColumns: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  ELEMENT_DATA: PeriodicElement[] = [];
  dataSource: PeriodicElement[] = this.ELEMENT_DATA;
  currentStartDate: moment.Moment;
  currentEndDate: moment.Moment;
  rangeStartDate: Date;
  rangeEndDate: Date;
  currentMonday: moment.Moment;
  today: Date;
  firstClick = true;
  secondClick = false;
  selectedWeekDay: string = null;
  selectedTime: string = null;
  selectedStartId: string;
  selectedEndId: string;
  weekdaysShortarr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  localeData: any;
  colorsInitialized = false;
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.colorsInitialized) {
      this.selectedTimeRange?.forEach(ele => {
        this.colorTimes(ele.dayOfWeek, ele.start, null, ele.end);
      });
      this.colorsInitialized = true;
    }
  }

  ngOnInit(): void {
    this.currentMonday = moment().startOf('isoWeeks');
    this.currentStartDate = this.currentMonday;
    this.currentEndDate = moment().endOf('isoWeeks');
    this.rangeStartDate = this.currentStartDate.toDate();
    this.rangeEndDate = this.currentEndDate.toDate();
    this.today = moment().startOf('day').toDate();
    this.populateDates();
    this.localeData = moment.updateLocale('en', {
      weekdaysShort: (momentToFormat) => {
        const day = momentToFormat.day();
        return this.weekdaysShortarr[day];
      }
    });
  }

  incrementDateRange() {
    this.currentStartDate = this.currentStartDate.add(7, 'days');
    this.currentEndDate = this.currentEndDate.add(7, 'days');
    this.rangeStartDate = this.currentStartDate.toDate();
    this.rangeEndDate = this.currentEndDate.toDate();
    this.populateDates();
  }

  decrementDateRange() {
    this.currentStartDate = this.currentStartDate.subtract(7, 'days');
    this.currentEndDate = this.currentEndDate.subtract(7, 'days');
    this.rangeStartDate = this.currentStartDate.toDate();
    this.rangeEndDate = this.currentEndDate.toDate();
    this.populateDates();
  }

  buttonClicked(day, hours, event) {
    console.log(this.timeRangeTable);
    var target = event.target || event.srcElement || event.currentTarget;
    const idEle = this.getNodeWithDateId(target);
    const weekDay = idEle.split("-")[0];
    const time = idEle.split("-")[1];
    console.log(day, ' ', hours, idEle);
    if (this.selectedWeekDay === null) {
      this.selectedWeekDay = weekDay;
    }
    if (this.selectedTime === null) {
      this.selectedTime = time;
    }
    if (this.firstClick && idEle !== undefined) {
      const btnEle = document.getElementById(idEle);
      const startWeekDay = idEle.split("-")[0];
      const startTime = idEle.split("-")[1];
      this.selectedStartId = idEle;
      const timeRange = this.selectedTimeRange.find(ele => ele.dayOfWeek === weekDay);
      if (!timeRange) {
        this.selectedTimeRange.push({ dayOfWeek: weekDay, start: startTime, end: '' });
      } else if (this.selectedTimeRange && timeRange.start != startTime) {
        this.selectedTimeRange.push({ dayOfWeek: weekDay, start: startTime, end: '' });
      }
      this.colorTimes(startWeekDay, startTime, null, null);
      this.firstClick = false;
      this.secondClick = true;
    } else if (!this.firstClick && this.secondClick && this.selectedWeekDay === weekDay) {
      const btnEle = document.getElementById(idEle);
      const endWeekDay = idEle.split("-")[0];
      const endTime = idEle.split("-")[1];

      const timeRangeIdx = this.selectedTimeRange.findIndex(ele => ele.dayOfWeek === weekDay && ele.start === this.selectedTime);
      const timeRangeExists = this.selectedTimeRange.findIndex(ele => ele.dayOfWeek === weekDay && (ele.start === endTime || ele.end === endTime));
      if (timeRangeExists < 0) {
        if (!timeRangeIdx) {
          this.selectedTimeRange[timeRangeIdx].end = endTime;
        } else if (timeRangeIdx) {
          this.selectedTimeRange[timeRangeIdx].end = endTime;
        }
        console.log(this.selectedTimeRange);
        this.selectedEndId = idEle;
        this.colorTimes(this.selectedWeekDay, this.selectedTime, endWeekDay, endTime);
        this.times.emit(this.selectedTimeRange);
      }

      this.firstClick = true;
      this.secondClick = false;
      this.selectedWeekDay = null;
      this.selectedTime = null;
      this.selectedStartId = '';
      this.selectedEndId = '';

    }
  }

  datePicked(isChecked, date) {
    console.log('date picked ', isChecked, ' ', date);
  }

  colorTimes(startWeekDay, startTime, endWeekDay, endTime) {
    const table = this.timeRangeTable.nativeElement;
    const startTimeNum = +startTime;
    const endTimeNum = +endTime;
    for (let i in table.rows) {
      if (i === '0') {
        continue;
      }
      let row = table.rows[i]

      for (let j in row.cells) {
        let col = row.cells[j]
        if (col.childNodes && col.childNodes.length > 0) {
          const btn = col.childNodes[0];
          const day = btn.id.split("-")[0];
          const time = btn.id.split("-")[1];
          const timeNum = +time;

          // !btn.parentElement.classList.contains('endTimeRange') && !btn.parentElement.classList.contains('startTimeRange') && !btn.parentElement.classList.contains('timeRange')
          if (startWeekDay !== null && startTime !== null && timeNum == startTimeNum && day == startWeekDay) {
            console.log('list ', btn.parentElement.classList);
            btn.parentElement.classList.add('startTimeRange');
            //btn.parentElement.childNodes[1].style = "display:inline-block; margin-left: 27px;";
          } else if (endWeekDay !== null && endTime !== null && timeNum == endTimeNum && day == endWeekDay && timeNum > startTimeNum) {
            btn.parentElement.classList.add('endTimeRange');
          } else if (endWeekDay !== null && endTime !== null && endWeekDay === day && timeNum > startTimeNum && timeNum < endTimeNum) {
            btn.parentElement.classList.add('timeRange');
          }
        }
      }
    }
  }

  getNodeWithDateId(ele) {
    var idElement: HTMLElement | null = ele;
    while (idElement && idElement.id === undefined) {
      idElement = idElement.parentElement;
    }
    if (idElement.id === undefined || idElement.id.length === 0) {
      idElement = idElement.parentElement;
    }
    return idElement.id;
  }

  populateDates() {
    const numDays = this.currentEndDate.diff(this.currentStartDate, 'days');

    console.log('monday ', this.currentMonday.toDate());
    this.ELEMENT_DATA = [];
    const dates = [];
    const countDate = this.currentStartDate.clone();
    dates.push(countDate.toDate())
    for (let i = 0; i < numDays; i++) {
      const date = countDate.add(1, 'days');
      dates.push(date.toDate());
    }

    this.ELEMENT_DATA.push({ time: '8 am', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '8', class: '', });
    this.ELEMENT_DATA.push({ time: '9 am', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '9', class: '', });
    this.ELEMENT_DATA.push({ time: '10 am', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '10', class: '', });
    this.ELEMENT_DATA.push({ time: '11 am', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '11', class: '', });
    this.ELEMENT_DATA.push({ time: '12 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '12', class: '', });
    this.ELEMENT_DATA.push({ time: '1 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '13', class: '', });
    this.ELEMENT_DATA.push({ time: '2 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '14', class: '', });
    this.ELEMENT_DATA.push({ time: '3 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '15', class: '', });
    this.ELEMENT_DATA.push({ time: '4 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '16', class: '', });
    this.ELEMENT_DATA.push({ time: '5 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '17', class: '', });
    this.ELEMENT_DATA.push({ time: '6 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '18', class: '', });
    this.ELEMENT_DATA.push({ time: '7 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '19', class: '', });
    this.ELEMENT_DATA.push({ time: '8 pm', mon: dates[0], tue: dates[1], wed: dates[2], thu: dates[3], fri: dates[4], sat: dates[5], sun: dates[6], hours: '20', class: '', });
    this.dataSource = this.ELEMENT_DATA;
  }

}
